export const importCopyToClipboard = async () =>
    (await import('copy-text-to-clipboard')).default;

export const createFacebookLink = (url: string) =>
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

export const createWhatsappLink = (url: string) =>
    `whatsapp://send?text=${encodeURIComponent(url)}`;

export const createTwitterLink = (url: string, title: string): string => {
    const text = encodeURIComponent(`Check out this ${title} on Zoopla`);
    return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        url
    )}&text=${text}&via=Zoopla`;
};

export const copyURLtoClipBoard = async (url: string) => {
    const copy = await importCopyToClipboard();

    if (copy(url)) {
        return Promise.resolve();
    }

    return Promise.reject();
};
